import { DeployEnvironments } from '~deploy-config/enviroments';

import { getBlogConfig } from '../../config';

const getDeployEnv = () => {
  switch (process.env.DEPLOY_PRODUCT_ENV) {
    case DeployEnvironments.VkCloudRu:
      return DeployEnvironments.VkCloudRu;
    case DeployEnvironments.VkCloudKz:
      return DeployEnvironments.VkCloudKz;
    case DeployEnvironments.HRTek:
      return DeployEnvironments.HRTek;
    case DeployEnvironments.Workspace:
      return DeployEnvironments.Workspace;
    case DeployEnvironments.Tarantool:
      return DeployEnvironments.Tarantool;
    case DeployEnvironments.Finops:
      return DeployEnvironments.Finops;
    case DeployEnvironments.Tech:
      return DeployEnvironments.Tech;
    default:
      return DeployEnvironments.VkCloudRu;
  }
};

export const env = {
  isDev: process.env.IS_DEV === 'true',
  isDevint: process.env.IS_DEVINT === 'true',
  isStage: process.env.IS_STAGE === 'true',
  isProd: process.env.IS_PROD === 'true',
  static: process.env.STATIC,
  deployEnv: getDeployEnv(),
  revalidateEnabled: process.env.REVALIDATE_ENABLED == '1',
  revalidateTime: Number(process.env.REVALIDATE_TIME_S) || null,
  blogConfig: getBlogConfig(),
};
